import React, { Component } from 'react'
import uuid from 'uuid'

export class Col extends Component {
  constructor(props) {
    super(props)
    this.id = uuid.v4()
  }
  
  static defaultProps = {
    editable: {
      type: 'layout/col',
      name: '列',
    },
    className: 'col-sm-12'
  }

  render() {
    const props = this.props
    const children = props.children
    //
    return (
      <div className={ props.className }>
        { children }
      </div>
    )
  }
}

export default Col



// WEBPACK FOOTER //
// ./app/javascript/app/site/components/layout/col/index.js